// extracted by mini-css-extract-plugin
export default {"card":"Cart_card__1AACi","hidden":"Cart_hidden__YMVCj","title":"Cart_title__caJvL","cart":"Cart_cart__2HXSz","cancel":"Cart_cancel__SP3+T","backdrop":"Cart_backdrop__SxAMZ"};